import React from 'react';
import styled from 'styled-components';
import PageShell from '../components/PageShell';
import { CornerCard } from '../components/ui';
import { color, font } from '../theme/tokens';

// --- 样式定义（与 Terms 保持一致） ---
const Content = styled(CornerCard)`
    max-width: 820px;
    margin: 0 auto;
    line-height: 1.95;
`;

const LastUpdated = styled.p`
    margin: 0 0 36px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${color.line};
    display: flex;
    align-items: baseline;
    gap: 14px;
    font-size: 13px;
    letter-spacing: 0.2em;
    color: ${color.text3};
    time { font-family: ${font.mono}; letter-spacing: 0.06em; color: ${color.text2}; }
`;

const SubHeading = styled.h2`
    display: flex;
    align-items: baseline;
    gap: 14px;
    margin: 44px 0 16px;
    font-family: ${font.display};
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.16em;
    color: ${color.text};
    span {
        font-family: ${font.mono};
        font-weight: 400;
        font-size: 13px;
        letter-spacing: 0.06em;
        color: ${color.bloodHi};
    }
`;

const Paragraph = styled.div`
    margin: 0 0 18px;
    font-size: 15px;
    color: ${color.text2};

    ul {
        list-style: none;
        padding-left: 0;
        margin: 14px 0;
    }

    li {
        position: relative;
        margin-bottom: 10px;
        padding-left: 22px;

        &::before {
            content: '';
            position: absolute;
            left: 2px;
            top: 0.85em;
            width: 8px;
            height: 1px;
            background: ${color.blood};
        }
    }

    strong {
        color: ${color.text};
        font-weight: 700;
    }
`;

const ContactInfo = styled.a`
    font-family: ${font.mono};
    color: ${color.bloodHi};
    text-decoration: none;
    border-bottom: 1px solid rgba(224, 70, 79, 0.45);
    padding-bottom: 1px;
    &:hover { color: ${color.textBright}; border-color: ${color.textBright}; }
`;

function Privacy() {
    return (
        <PageShell title="隠私" en="PRIVACY">
            <Content pad="48px 56px">
                <LastUpdated>最后修订 <time dateTime="2025-10-05">2025.10.05</time></LastUpdated>

                <Paragraph>
                    感谢您信任 終ノ空.com。数据安全是我们的核心协议。本策略文件旨在说明系统如何采集、处理及加密您的个人数据。
                </Paragraph>

                <SubHeading><span>01</span>数据采集</SubHeading>
                <Paragraph>
                    为了维持核心服务运行，我们仅请求以下必要参数：
                    <ul>
                        <li><strong>用户名：</strong> 用于在网络中唯一标识您的实体。</li>
                        <li><strong>密码：</strong> 系统将对其进行高强度哈希加密存储，管理员无法反向解析获取您的原始密钥。</li>
                    </ul>
                    系统<strong>不追踪</strong>您的真实姓名、物理地址、电子邮件（除非用于密码重置）或其他敏感生物识别信息。
                </Paragraph>

                <SubHeading><span>02</span>数据用途</SubHeading>
                <Paragraph>
                    采集的数据包仅用于以下进程：
                    <ul>
                        <li>验证身份以授予系统访问权限。</li>
                        <li>维护服务器防火墙及提升系统稳定性。</li>
                    </ul>
                </Paragraph>

                <SubHeading><span>03</span>数据披露</SubHeading>
                <Paragraph>
                    <strong>承诺：我们绝不向第三方节点出售、交换或出租您的核心数据。</strong>
                    仅在以下极少数异常状态下触发数据披露：
                    <ul>
                        <li>法律法规的强制性指令或更高权限部门要求。</li>
                        <li>为防御针对系统的恶意攻击，保护整体网络安全所必需。</li>
                    </ul>
                </Paragraph>

                <SubHeading><span>04</span>安全措施</SubHeading>
                <Paragraph>
                    我们部署了行业标准的加密算法来保护数据存储。但请注意，基于现有物理法则，没有任何网络传输是绝对零风险的，我们无法承诺 100% 的绝对防御。
                </Paragraph>

                <SubHeading><span>05</span>数据保留</SubHeading>
                <Paragraph>
                    只要您的账户处于活跃状态，数据将被保留在热存储中。若执行注销指令，相关个人数据将从活动数据库中永久擦除。
                </Paragraph>

                <SubHeading><span>06</span>策略更新</SubHeading>
                <Paragraph>
                    策略库可能会进行补丁更新。新版本将覆盖当前页面。建议定期执行查询操作。
                </Paragraph>

                <SubHeading><span>07</span>联系管理员</SubHeading>
                <Paragraph>
                    如对隐私政策有疑问，请联系：<ContactInfo href="mailto:abyss.gate@outlook.com">abyss.gate@outlook.com</ContactInfo>
                </Paragraph>
            </Content>
        </PageShell>
    );
}

export default Privacy;
